import { useMutation } from "react-query";
import { RelatorioPrestacaoContasForm } from "../typings";
import http from "infra/http";

function useSaveRelatorioPrestacaoContas() {
  return useMutation(
    (data: RelatorioPrestacaoContasForm) => {
      if (data.id) {
        return http.put(`/v1/relatorios/financeiro/prestacao-contas/${data.id}`, data);
      }
      
      return http.post(`/v1/relatorios/financeiro/prestacao-contas`, data);
    },
    { retry: false }
  );
}

export default useSaveRelatorioPrestacaoContas;
